import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import { Cards } from 'src/components';
import { Triangle, TriangleDown } from 'src/utils/mdIcons';


const useStyles = makeStyles(theme => ({
  landClass: {
    fontStyle: 'italic',
  },
  year: {
    marginRight: theme.spacing(0.5),
  },
  trendIconUp: {
    fontSize: '0.5rem',
    fontWeight: 600,
    color: theme.palette.success.main,
  },
  trendIconDown: {
    fontSize: '0.5rem',
    fontWeight: 600,
    color: theme.palette.error.main,
  },
  percentUp: {
    color: theme.palette.success.main,
    fontWeight: 600,
  },
  percentDown: {
    color: theme.palette.error.main,
    fontWeight: 600,
  },
  percentEqual: {
    color: theme.palette.common.gray600,
    fontWeight: 600,
  },
}));

const LandcoverTable = ({ data, year1, year2 }) => {
  const dataset = data.datasets;
  const indexYear1 = data.labels.indexOf(year1);
  const indexYear2 = data.labels.indexOf(year2);

  const classes = useStyles();

  const cardsRef = useRef();

  const columns = [
    {
      title: 'Clase',
      render: ({ label }) => <Box className={classes.landClass}>{label}</Box>,
    },
    {
      title: `${year1} [ha]`,
      render: ({ data }) => (
        <Box className={classes.year}>
          {typeof data[indexYear1] === 'number'
            ? data[indexYear1].toLocaleString('es-CL')
            : data[indexYear1]}
        </Box>
      ),
    },
    {
      title: `${year2} [ha]`,
      render: ({ data }) => (
        <Box className={classes.year}>
          {typeof data[indexYear2] === 'number'
            ? data[indexYear2].toLocaleString('es-CL')
            : data[indexYear2]}
        </Box>
      ),
    },
    {
      title: 'Variación',
      render: ({ data }) => {
        const variation = Math.round((data[indexYear2] - data[indexYear1]) / data[indexYear1] * 100);
        return (
          <Box display="flex" alignItems="center" className={classes.year}>
            {
              variation > 0 ? <Triangle className={classes.trendIconUp} />
              : variation < 0 ? <TriangleDown className={classes.trendIconDown} />
              : null
            }
            <Typography
              variant="body2"
              className={
                variation > 0 ? classes.percentUp :
                variation < 0 ? classes.percentDown :
                classes.percentEqual
              }
              component="span"
            >
              &nbsp;{Math.abs(variation)}%
            </Typography>
          </Box>
        );
      },
    },
  ];

  return (
    <>
      <Cards ref={cardsRef} values={dataset} variant="condensed" columns={columns} />
    </>
  );
};

LandcoverTable.propTypes = {
  data: PropTypes.object,
  year1: PropTypes.number,
  year2: PropTypes.number,
};


export { LandcoverTable };